import React from 'react';
import {CustomizeItemContext} from '../../CustomizeItemContext';
import {PoolCustomizeItemSelectOption} from 'api';

export default () => {
  const {selectOptionsGroupByPriority} = React.useContext(CustomizeItemContext);
  return (
    <div className="flex flex-col gap-2">
      {Object.entries(selectOptionsGroupByPriority ?? {})?.map(
        ([priority, options]: any) => {
          return (
            <div className="flex gap-2" key={priority}>
              <div className="font-bold text-sm">優先度{priority}</div>
              <div className="flex items-center gap-2 text-sm">
                {options
                  ?.map((option: PoolCustomizeItemSelectOption) => {
                    return option?.label;
                  })
                  ?.join(' | ')}
              </div>
            </div>
          );
        },
      )}
    </div>
  );
};
